import { Link } from "react-router-dom";
import {
  FiFacebook,
  FiLinkedin,
  FiInstagram,
  FiTwitter,
  FiMail,
  FiPhone,
  FiMapPin,
} from "../../assets/icons/vander";

export const Footer = () => {
  return (
    <>
      <footer className="">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 mb-0 mb-md-4 pb-0 pb-md-2">
              <Link to="#" className="logo-footer text-white">
                GOSAFE
              </Link>
            </div>

            <div className="col-lg-9 col-md-12">
              <div className="row">
                <div className="col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <h5 className="footer-head">Navegación</h5>
                  <ul className="list-unstyled footer-list mt-4">
                    <li>
                      <Link to="/auth/signup" className="text-foot">
                        <i className="mdi mdi-chevron-right me-1"></i>{" "}
                        Crea tu cuenta
                      </Link>
                    </li>
                    <li>
                      <Link to="/auth/login" className="text-foot">
                        <i className="mdi mdi-chevron-right me-1"></i> Iniciar
                        sesión
                      </Link>
                    </li>
                  </ul>
                </div>

                <div className="col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <h5 className="footer-head">Funciones</h5>
                  <ul className="list-unstyled footer-list mt-4">
                    <li>
                      <Link to="#" className="text-foot">
                        <i className="mdi mdi-chevron-right me-1"></i> Registro
                        Médicos
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="text-foot">
                        <i className="mdi mdi-chevron-right me-1"></i> Registro
                        Pacientes
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="text-foot">
                        <i className="mdi mdi-chevron-right me-1"></i>{" "}
                        Disponibilidad de Salas de procecimientos
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="text-foot">
                        <i className="mdi mdi-chevron-right me-1"></i>{" "}
                        Disponibilidad de agendas médicas
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="text-foot text-align-center">
                        <i className="mdi mdi-chevron-right me-1"></i>{" "}
                        Agendamiento citas pacientes anestesiología
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="text-foot">
                        <i className="mdi mdi-chevron-right me-1"></i>{" "}
                        Agendamiento citas pacientes cirugía
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="text-foot">
                        <i className="mdi mdi-chevron-right me-1"></i>{" "}
                        Seguimiento pacientes
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="text-foot">
                        <i className="mdi mdi-chevron-right me-1"></i>{" "}
                        Disponibilidad de agendas médicas
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="text-foot">
                        <i className="mdi mdi-chevron-right me-1"></i> Nuevas
                        citas de control
                      </Link>
                    </li>
                  </ul>
                </div>

                <div className="col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <h5 className="footer-head">Contáctanos</h5>
                  <ul className="list-unstyled footer-list mt-4">
                    <li className="d-flex align-items-center">
                      <FiMail className="fea icon-sm text-foot align-middle" />
                      <Link
                        to="mailto:sedattiva.met@gmail.com"
                        className="text-foot ms-2"
                      >
                        sedattiva.met@gmail.com
                      </Link>
                    </li>

                    <li className="d-flex align-items-center">
                      <FiPhone className="fea icon-sm text-foot align-middle" />
                      <Link to="tel:+57323-293-9282" className="text-foot ms-2">
                        +57 323 293 9282
                      </Link>
                    </li>

                    <li className="d-flex align-items-center">
                      <FiMapPin className="fea icon-sm text-foot align-middle" />
                      <Link
                        to="https://www.clubser.co/"
                        target="_blank"
                        className="video-play-icon text-foot ms-2"
                      >
                        Encuéntranos en google maps
                      </Link>
                    </li>
                  </ul>

                  <ul className="list-unstyled social-icon footer-social mb-0 mt-4">
                    <li className="list-inline-item">
                      <Link to="#" className="rounded-pill">
                        <FiFacebook className="fea icon-sm fea-social" />
                      </Link>
                    </li>
                    <li className="list-inline-item">
                      <Link to="#" className="rounded-pill">
                        <FiInstagram className="fea icon-sm fea-social" />
                      </Link>
                    </li>
                    <li className="list-inline-item">
                      <Link to="#" className="rounded-pill">
                        <FiTwitter className="fea icon-sm fea-social" />
                      </Link>
                    </li>
                    <li className="list-inline-item">
                      <Link to="#" className="rounded-pill">
                        <FiLinkedin className="fea icon-sm fea-social" />
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};
